(() => {
  const bind = (root) => {
    if (!root || root.dataset.packitReviewBound === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-packit-review-slide]'));
    const previous = root.querySelector('[data-packit-review-prev]');
    const next = root.querySelector('[data-packit-review-next]');
    if (slides.length < 2 || !previous || !next) return;
    root.dataset.packitReviewBound = 'true';
    let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const current = slideIndex === active;
        slide.classList.toggle('is-active', current);
        slide.setAttribute('aria-hidden', current ? 'false' : 'true');
      });
    };

    previous.addEventListener('click', () => show(active - 1));
    next.addEventListener('click', () => show(active + 1));
  };

  const bindAll = (scope = document) => scope.querySelectorAll('[data-packit-reviews]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindAll());
  else bindAll();
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
